import { lazy } from "react";

export default [
  {
    exact: true,
    path: ["/:customerName/requests/:tab", "/:customerName/requests/"],
    component: lazy(() =>
      import("src/views/arkadu/corporate/petitions/CorporatePetitionsIndex")
    ),
  },
  {
    exact: true,
    path: "/:customerName/requests/detail/:id",
    component: lazy(() =>
      import("src/views/arkadu/corporate/petitions/PetitionDetailViewWrapper")
    ),
  },
];
